import { render, staticRenderFns } from "./CommissionSubscriptions.vue?vue&type=template&id=1095a516&scoped=true&lang=pug&"
import script from "./CommissionSubscriptions.vue?vue&type=script&lang=ts&"
export * from "./CommissionSubscriptions.vue?vue&type=script&lang=ts&"
import style0 from "./CommissionSubscriptions.vue?vue&type=style&index=0&id=1095a516&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1095a516",
  null
  
)

export default component.exports